import { render, staticRenderFns } from "./ContractAction.vue?vue&type=template&id=2a731fb0&scoped=true"
import script from "./ContractAction.vue?vue&type=script&lang=js"
export * from "./ContractAction.vue?vue&type=script&lang=js"
import style0 from "./ContractAction.vue?vue&type=style&index=0&id=2a731fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a731fb0",
  null
  
)

export default component.exports